import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { clearTaxTypeDetails } from "../../app/certificateSlice";
import type { AppDispatch } from "../../app/types";

/**
 * Clears the Redux tax-type-details cache whenever the active company changes.
 * Each company has its own TaxType tree, so stale data from a previous company
 * must be evicted before the next fetch runs.
 *
 * Extracted from `Application.tsx` to keep that component focused on
 * session-level concerns.
 */
export const useClearTaxTypeDetailsOnCompanyChange = (
    companyId: string | number | null | undefined
): void => {
    const dispatch = useDispatch<AppDispatch>();
    const previousCompanyIdRef = useRef<string | number | null>(null);

    useEffect(() => {
        const current = companyId ?? null;
        if (
            previousCompanyIdRef.current !== null &&
            current !== null &&
            previousCompanyIdRef.current !== current
        ) {
            dispatch(clearTaxTypeDetails());
        }
        previousCompanyIdRef.current = current;
    }, [dispatch, companyId]);
};
